import { render, staticRenderFns } from "./RegisterAnother.vue?vue&type=template&id=393bca8a&scoped=true"
import script from "./RegisterAnother.vue?vue&type=script&lang=js"
export * from "./RegisterAnother.vue?vue&type=script&lang=js"
import style0 from "./RegisterAnother.vue?vue&type=style&index=0&id=393bca8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393bca8a",
  null
  
)

export default component.exports